<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-fournisseur-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form ref="fournisseurForm" @submit="editFournisseur" :validation-schema="fournisseurSchema">
        <div class="row">
          <!-- Statut -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Statut<span class="text-danger">*</span>
              </label>
              <Field name="statut" v-slot="{ field }">
                <Multiselect
                  :options="statut"
                  :searchable="true"
                  track-by="label"
                  label="label"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner le statut"
                  @select="handleObjetInput"
                />
              </Field>
            </div>
            <ErrorMessage name="statut" class="text-danger" />
          </div>

          <!-- Personne physique -->
          <div class="col-md-4 mb-3" v-if="showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom du fournisseur <span class="text-danger">*</span>
              </label>
              <Field name="nomFournisseur" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le nom" />
              <ErrorMessage name="nomFournisseur" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3" v-if="showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Prénom du fournisseur<span class="text-danger">*</span>
              </label>
              <Field name="prenomFournisseur" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le prénom" />
              <ErrorMessage name="prenomFournisseur" class="text-danger" />
            </div>
          </div>

          <!-- Personne morale -->
          <div class="col-md-4 mb-3" v-if="!showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Sigle <span class="text-danger">*</span>
              </label>
              <Field name="sigle" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le sigle" />
              <ErrorMessage name="sigle" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3" v-if="!showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Dénomination <span class="text-danger">*</span>
              </label>
              <Field name="denomination" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la dénomination" />
              <ErrorMessage name="denomination" class="text-danger" />
            </div>
          </div>

          <!-- IFU -->
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                IFU <span class="text-danger" v-if="!showAdditionalFields">*</span>
              </label>
              <Field name="ifu" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'ifu" />
              <ErrorMessage name="ifu" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3" v-if="!showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Registre de commerce <span class="text-danger">*</span>
              </label>
              <Field name="rccm" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le registre de commerce" />
              <ErrorMessage name="rccm" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Adresse</label>
              <Field name="adresseFournisseur" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'adresse" />
              <ErrorMessage name="adresseFournisseur" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Email</label>
              <Field name="email" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer l'email" />
              <ErrorMessage name="email" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4 mb-3" v-if="showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Sexe <span class="text-danger">*</span>
              </label>
              <Field name="sexe" type="text" v-slot="{ field }">
                <Multiselect
                  :searchable="true"
                  :options="['Masculin', 'Féminin']"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionner le sexe"
                />
              </Field>
              <ErrorMessage name="sexe" class="text-danger" />
            </div>
          </div>

          <!-- Téléphones -->
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Téléphone 1 <span class="text-danger">*</span>
              </label>
              <Field name="telFournisseur1" v-slot="{ field }">
                <vue-tel-input
                  placeholder="Entrer le numéro de téléphone"
                  v-model="field.value"
                  v-bind="field"
                  defaultCountry="BJ"
                  mode="international"
                  @validate="validatePhone1"
                  class="shadow-none fs-md-15 text-black py-2">
                </vue-tel-input>
              </Field>
              <div v-if="!validPhone1" class="text-danger">Veuillez entrer un numéro correct</div>
              <ErrorMessage name="telFournisseur1" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Téléphone 2</label>
              <Field name="telFournisseur2" v-slot="{ field }">
                <vue-tel-input
                  placeholder="Entrer le numéro de téléphone"
                  v-model="field.value"
                  v-bind="field"
                  defaultCountry="BJ"
                  mode="international"
                  @validate="validatePhone2"
                  class="shadow-none fs-md-15 text-black py-2">
                </vue-tel-input>
              </Field>
              <div v-if="!validPhone2" class="text-danger">Veuillez entrer un numéro correct</div>
              <ErrorMessage name="telFournisseur2" class="text-danger" />
            </div>
          </div>

          <!-- Date de création (personne morale) -->
          <div class="col-md-4" v-if="!showAdditionalFields">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Date de création</label>
              <Field name="dateCreation" type="date" :max="currentDate"
                class="form-control shadow-none fs-md-15 text-black" />
            </div>
            <ErrorMessage name="dateCreation" class="text-danger" />
          </div>

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button ref="submitButton" class="btn btn-success me-3" type="submit">
                Modifier le fournisseur
              </button>
              <router-link to="/fournisseurs/liste-fournisseurs" class="btn btn-danger">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import Multiselect from '@vueform/multiselect';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import { VueTelInput } from 'vue3-tel-input';

export default defineComponent({
  name: 'EditFournisseur',
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    VueTelInput,
  },

  setup: () => {
    const router = useRouter();
    const route = useRoute();

    const currentDate = ref(new Date().toISOString().split('T')[0]);
    const fournisseurForm = ref<any>(null);
    const submitButton = ref<HTMLButtonElement | null>(null);

    // true = personne physique (statut 1), false = personne morale (statut 2)
    const showAdditionalFields = ref(true);

    const validPhone1 = ref<boolean>(true);
    const validPhone2 = ref<boolean>(true);

    const statut = [
      { value: 1, label: 'Personne physique' },
      { value: 2, label: 'Personne morale' },
    ];

    const fournisseurSchema = Yup.object().shape({
      statut: Yup.string().required('Le statut est obligatoire'),
      nomFournisseur: Yup.string().when([], (_value, schema) =>
        showAdditionalFields.value ? schema.required('Le nom du fournisseur est obligatoire') : schema.notRequired()
      ),
      prenomFournisseur: Yup.string().when([], (_value, schema) =>
        showAdditionalFields.value ? schema.required('Le prénom du fournisseur est obligatoire') : schema.notRequired()
      ),
      sexe: Yup.string().when([], (_value, schema) =>
        showAdditionalFields.value ? schema.required('Le sexe est obligatoire') : schema.notRequired()
      ),
      sigle: Yup.string().when([], (_value, schema) =>
        !showAdditionalFields.value ? schema.required('Le sigle est obligatoire') : schema.notRequired()
      ),
      denomination: Yup.string().when([], (_value, schema) =>
        !showAdditionalFields.value ? schema.required('La dénomination est obligatoire') : schema.notRequired()
      ),
      rccm: Yup.string().when([], (_value, schema) =>
        !showAdditionalFields.value ? schema.required('Le rccm est obligatoire') : schema.notRequired()
      ),
      ifu: Yup.string()
        .matches(/^\d{13}$/, { message: 'La saisie doit avoir exactement 13 chiffres', excludeEmptyString: true })
        .when([], (_value, schema) =>
          !showAdditionalFields.value ? schema.required("L'ifu est obligatoire") : schema.notRequired()
        ),
      dateCreation: Yup.date()
        .nullable()
        .transform((value, originalValue) => (originalValue === '' ? null : value)),
      adresseFournisseur: Yup.string().notRequired(),
      email: Yup.string().email('Veuillez entrer un mail valide').notRequired(),
      telFournisseur1: Yup.string().required('Le téléphone 1 est obligatoire'),
      telFournisseur2: Yup.string().notRequired(),
    });

    function validatePhone1(phoneObject: any) {
      validPhone1.value = !!phoneObject.valid;
    }

    // Le téléphone 2 est optionnel : on ne signale une erreur que s'il est renseigné
    function validatePhone2(phoneObject: any) {
      validPhone2.value = !phoneObject.number ? true : !!phoneObject.valid;
    }

    const handleObjetInput = (selectedValue: any) => {
      showAdditionalFields.value = Number(selectedValue) === 1;
    };

    // Champs de la réponse API à ne pas injecter dans le formulaire
    const ignoredKeys = ['id', 'createdAt', 'updatedAt', 'deletedAt', 'approvisionnements'];

    function getFournisseur(id: number) {
      ApiService.get('/fournisseurs/' + id.toString())
        .then(({ data }) => {
          const fournisseur = data.data;

          // On définit d'abord le type d'affichage pour que les bons champs se montent
          showAdditionalFields.value = Number(fournisseur.statut) === 1;

          for (const key in fournisseur) {
            if (ignoredKeys.includes(key)) continue;
            const value = fournisseur[key];

            if (key === 'statut') {
              // Le backend renvoie "1"/"2" (chaîne) mais les options du Multiselect sont numériques
              fournisseurForm.value?.setFieldValue('statut', Number(value));
            } else if (key === 'dateCreation') {
              fournisseurForm.value?.setFieldValue(key, value ? String(value).split('T')[0] : '');
            } else {
              // null -> '' pour éviter l'erreur de type Yup sur les champs optionnels
              fournisseurForm.value?.setFieldValue(
                key,
                value === null || value === undefined ? '' : typeof value === 'object' ? value.id : value
              );
            }
          }
        })
        .catch(({ response }) => {
          error(response?.data?.message ?? 'Impossible de charger le fournisseur.');
        });
    }

    onMounted(() => {
      if (route.params.id) {
        getFournisseur(parseInt(route.params.id as string));
      }
    });

    const editFournisseur = async (values: any) => {
      if (!validPhone1.value || !validPhone2.value) {
        error('Veuillez corriger les numéros de téléphone.');
        return;
      }

      if (submitButton.value) {
        submitButton.value.disabled = true;
      }

      ApiService.put('/fournisseurs/' + route.params.id, values)
        .then(({ data }) => {
          if (data.code == 200) {
            success(data.message);
            router.push({ name: 'ListeFournisseur' });
          }
        })
        .catch(({ response }) => {
          if (submitButton.value) {
            submitButton.value.disabled = false;
          }
          error(response?.data?.message ?? 'La modification a échoué.');
        });
    };

    return {
      fournisseurForm,
      fournisseurSchema,
      statut,
      showAdditionalFields,
      handleObjetInput,
      currentDate,
      submitButton,
      validPhone1,
      validPhone2,
      validatePhone1,
      validatePhone2,
      editFournisseur,
    };
  },
});
</script>

<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}
.marge-droite {
  margin-left: 15px;
}
.hr-longeur {
  width: 80%;
}
.bord1 {
  border: 1px solid #07a;
}
.fond {
  background-color: rgb(94, 191, 233);
}
</style>